'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$() {
  this.aKX = null;
  this.aKY = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$.prototype = $p;
$p.aA = (function() {
  if ((!this.aKY)) {
    this.aKX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aKY = true;
  }
  return this.aKX;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$, "app.data.data_point_types$package$IncotermLocation$", ({
  FS: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$ };
//# sourceMappingURL=app.data.data_point_types$package$-Incoterm-Location$.js.map
